<template>
  <div :class="[{ active: active }, 'saved-portfolio-item']">
    <div class="new-item" v-if="newItem"></div>
    <div class="portfolio-props" @click="handleRetrievePortfolio">
      <div :class="[{ wrap: !hasWhiteSpace(name) }, 'flex title-container']">
        <p :class="[{ new: newItem }, 'portfolio-name']">{{ name }}</p>
        <div class="status-container" v-if="!analyzed">
          {{ $t("portfolioManager.notAnalyzed") }}
        </div>
      </div>
      <div class="portfolio-date">
        {{ $t("portfolioManager.poolSidebar.lastChange") }}: {{ tDate }}
      </div>
    </div>
    <div class="controls">
      <rename-icon @click="handleRenamePortfolio" />
      <b-spinner v-if="isRemoving" small />
      <delete-icon @click="handleRemovePortfolio" v-else />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import DeleteIcon from "vue-material-design-icons/DeleteOutline.vue";
import MainAlert from "./alerts/MainAlert.vue";
import { RENAME_PORTFOLIO } from "../utils/constants";
import RenameIcon from "vue-material-design-icons/Pencil.vue";
import moment from "moment";
export default {
  name: "savedPortfolioItem",
  components: {
    DeleteIcon,
    RenameIcon,
  },
  props: {
    name: String,
    date: [String, Date],
    id: Number,
    idVersion: [Number, String],
    active: Boolean,
  },
  data() {
    return {
      isRemoving: false,
    };
  },
  methods: {
    ...mapActions("portfolioManagerStore", [
      "savePortfolio",
      "retrieveOptimizedPortfolio",
      "clearPortfolio",
    ]),
    ...mapMutations("portfolioManagerStore", [
      "openImportedPortfolio",
      "setSaveModalItem",
    ]),
    handleRemovePortfolio() {
      this.isRemoving = true;
      this.savePortfolio({
        portfolio_id: this.id,
        name: "",
      })
        .then(() => {
          this.clearPortfolio(true);
          this.$toast.success({
            component: MainAlert,
            props: {
              message: this.$i18n.t(
                "portfolioManager.portfoliosSidebar.portfolioDeleted"
              ),
            },
          });
        })
        .catch(() =>
          this.$toast.error({
            component: MainAlert,
            props: {
              message: this.$i18n.t("errors.actionFailed"),
            },
          })
        )
        .finally(() => (this.isRemoving = false));
    },
    handleRenamePortfolio() {
      this.setSaveModalItem({ type: RENAME_PORTFOLIO, id: this.id });
      this.$bvModal.show("save-modal");
    },
    handleRetrievePortfolio() {
      this.clearPortfolio(false);
      this.retrieveOptimizedPortfolio({ id: this.idVersion, analyze: false });
      this.openImportedPortfolio(this.id);
    },
    hasWhiteSpace(text) {
      return /\s/g.test(text);
    },
  },
  computed: {
    ...mapGetters("portfolioManagerStore", [
      "newImportedPortfolios",
      "notCalculatedPortfolios",
    ]),
    tDate() {
      const format =
        this.$i18n.locale === "cs" ? "DD. MM. YY HH:mm" : "MM/DD/YY HH:mm";
      return moment(this.date).format(format);
    },
    newItem() {
      return this.newImportedPortfolios.includes(this.id);
    },
    analyzed() {
      return (
        this.notCalculatedPortfolios.filter(
          (item) => item.last_history_obj.history_id === this.idVersion
        ).length === 0
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.saved-portfolio-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 4px 8px;
  border-bottom: 1px solid #edf1ff;
  &.active {
    background: #f1f3ff;
    .portfolio-name {
      color: $headingsColor;
    }
  }
  .new-item {
    padding-right: 5px;
    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      -moz-border-radius: 7.5px;
      -webkit-border-radius: 7.5px;
      border-radius: 7.5px;
      background-color: $primaryFontBlue;
    }
  }
  .portfolio-props {
    cursor: pointer;
  }
  .portfolio-name {
    font-size: $s-font;
    font-weight: 500;
    margin-bottom: 0px;
    &.new {
      color: $primaryFontBlue;
    }
  }
  .title-container {
    margin-bottom: 7px;
    &.wrap {
      flex-wrap: wrap;
      .status-container {
        margin-left: 0;
      }
    }
  }
  .portfolio-date {
    font-size: $xs-font;
    color: $subtleText;
    white-space: nowrap;
  }
  .status-container {
    background: #e2eafe;
    color: $primaryColor;
    border-radius: toRem(10);
    padding: 2px 7px;
    height: fit-content;
    white-space: nowrap;
    font-weight: 300;
    margin-left: toRem(5);
    display: flex;
    align-items: center;
    font-size: toRem(11);
  }
  .material-design-icon {
    color: $primaryColor;
    cursor: pointer;
  }
  .pencil-icon {
    margin-right: 8px;
  }
  .controls {
    display: flex;
    min-width: 50px;
  }
}
</style>